// extracted by mini-css-extract-plugin
export default {"screen_container":"CourseScreen_screen_container__VulXj","courses_container":"CourseScreen_courses_container__6TVaO"};